// extracted by mini-css-extract-plugin
export default {"wrapper":"itkByLGIvbEYw6xDtenK","breadcrumb":"nwaJQhvjwptN2STky_Nx","actions":"LhMAxA4iV687U_X4lD1D"};